import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { Wordmark } from './Wordmark';

export const SiteFooter = () => (
  <footer className="py-12 md:py-14 px-5 md:px-6 bg-[#0B0F14] border-t border-[#C8A45D]/15" data-testid="site-footer">
    <div className="max-w-7xl mx-auto text-center flex flex-col items-center">
      <Wordmark />
      <p className="text-[#B9A98A] text-sm mt-4 mb-7 italic">Jewelry for Power, Myth, and Legacy.</p>
      <div className="flex gap-5 justify-center">
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-[#C8A45D] hover:text-[#E6D3A3] transition-colors duration-300" aria-label="Instagram">
          <Instagram className="w-5 h-5" strokeWidth={1.25} />
        </a>
        <a href="mailto:house@ikaruslanded.com" className="text-[#C8A45D] hover:text-[#E6D3A3] transition-colors duration-300" aria-label="Email">
          <Mail className="w-5 h-5" strokeWidth={1.25} />
        </a>
      </div>
    </div>
  </footer>
);
